import packageJson from '../package.json';

export type ConfigValue = {
  appName: string;
  appVersion: string;
  serverUrl: string;
  assetsDir: string;
  qualtricsCheckInUrls: Record<string, string>;
};

export const CONFIG: ConfigValue = {
  appName: 'LTA Activators',
  appVersion: packageJson.version,
  serverUrl: import.meta.env.VITE_SERVER_URL ?? '',
  assetsDir: import.meta.env.VITE_ASSETS_DIR ?? '',
  qualtricsCheckInUrls: {
    '1': import.meta.env.VITE_QUALTRICS_CHECKIN_1_URL ?? '',
    '2': import.meta.env.VITE_QUALTRICS_CHECKIN_2_URL ?? '',
    '3': import.meta.env.VITE_QUALTRICS_CHECKIN_3_URL ?? '',
  },
};
